import {
  Directive, Input, TemplateRef, inject,
} from '@angular/core'

@Directive({
  selector: 'ng-template[kbTemplateType]',
  standalone: true,
})
export class TemplateTypeDirective<TypeToken> {
  @Input({
    alias: 'kbTemplateType',
    required: true,
  })
  public typeToken!: TypeToken

  private contentTemplate = inject(TemplateRef<TypeToken>)

  // this magic is how we tell Angular the context type for this directive, which then propagates down to the type of the template
  public static ngTemplateContextGuard<TypeToken>(dir: TemplateTypeDirective<TypeToken>, ctx: unknown): ctx is TypeToken {
    return true
  }
}
